<template>
        <div :class="operationLimitation !== false ? 'has_error' : ''">
            <form class="form-inline" @submit.prevent="saveAction">
                <label class="mr-sm-2" for="operation">Výkon</label>
                <div class="col-md-6">
                    <multiselect v-model="selected" ref="addActionSearchInput" label="label" track-by="code" placeholder="vyhledat výkon" open-direction="bottom" :options="operations" :multiple="false" :searchable="true" :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getOperations" @select="selectOperation" selectLabel="" :data-testid="'visit-action-search-' + diagnosisId"></multiselect>
                </div>

                <i title="interní výkon" v-if="action.internal" @click="changeInternal" class="fa fa-hand-spock-o fa-2x text-danger" aria-hidden="true" :data-testid="'visit-action-internal-' + diagnosisId"></i>
                <i title="běžný výkon" v-else="" @click="changeInternal" class="fa fa-hand-paper-o fa-2x text-light fa-flip-horizontal" aria-hidden="true" :data-testid="'visit-action-internal-' + diagnosisId"></i>
                <label class="form-check-label ml-sm-2">Vykazovat</label>
                <input v-model="action.reported"  class="form-check-input mr-sm-2 form-control-sm" type="checkbox" id="inlineCheckbox1" value="option1" :data-testid="'visit-action-reported-' + diagnosisId">
                <label for="amount" class="ml-sm-2 mr-sm-2">Počet</label>
                <input v-model="action.quantity" type="number" class="form-control mr-sm-2 form-control-sm col-sm-1" aria-describedby="operationHelp" id="amount" :data-testid="'visit-action-quantity-' + diagnosisId">

                <button v-if="selected !== ''" type="button" id="infoActionButton" @click="showModalOperationInfo" class="btn btn-sm btn-outline-primary mr-sm-2"><i class="fa fa-info-circle"></i></button>
                <a v-else="" href="#" class="btn btn-sm btn-outline-secondary disabled mr-sm-2" id="infoActionButtonDisabled" aria-disabled="true"><i class="fa fa-info-circle"></i></a>

                <button v-if="!actionPending" type="submit" id="addActionButton" class="btn btn-sm btn-success" :data-testid="'visit-action-add-' + diagnosisId">Přidat</button>
                <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            </form>
            <div class="ml-5">
                <span v-if="operationLimitation" class="text-danger font-weight-bold">
                    <span v-for="ol in operationLimitation">
                        Lze vykázat maximálně {{ ol.per_period }} za {{ ol.number_of_periods }} {{ ol.type | toCSBasedOnNumber(ol.number_of_periods) }}.&nbsp;
                    </span>
                </span>
            </div>
        </div>
</template>

<script>
  // import { mapState, mapActions } from 'vuex'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        selected: '',
        // operations
        operations: [],
        operationsError: false,
        operationsPending: false,
        // action (post)
        action: {
          operation: '',
          quantity: 1,
          reported: true,
          internal: false
        },
        actionPending: false,
        actionDone: false,
        actionError: false,
        // Operation limitation check
        operationLimitationPending: false,
        operationLimitation: false,
        operationLimitationError: false,
        // operation info modal
        modalOperationInfoOpened: false
      }
    },
    props: ['diagnosisId', 'focusInput', 'diagnosisListIndex'],
    mixins: [apiMixin],
    methods: {
      saveAction () {
        this.postAction(this.diagnosisId, this.action)
      },
      getOperations (search) {
        this.operationLimitation = false
        this.operationLimitationError = false
        if (search.length > 2) {
          this.searchOperations({search: search})
        }
      },
      selectOperation (val) {
        this.operationLimitation = false
        this.operationLimitationError = false
        this.action.operation = val.code // TODO - change
        document.getElementById('addActionButton').focus()
      },
      changeInternal () {
        this.action.internal = !this.action.internal
      },
      showModalOperationInfo () {
        this.$emit('openOperationModal', this.selected)
      }
    },
    beforeMount () {
    },
    watch: {
      focusInput (val) {
        if (val === true) {
          console.log('focusuji input')
          this.$refs.addActionSearchInput.$el.focus()
          this.$emit('focused')
        }
      },
      actionDone (val) {
        if (val === true) {
          this.operationLimitation = false
          this.operationLimitationError = false
          this.action = {
            operation: '',
            quantity: 1,
            reported: true,
            internal: false
          }
          this.$emit('update')
          this.actionDone = false
          this.operations = []
          this.selected = ''
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.selected {
        background-color: deeppink;
    }

    .highlight_hovered tr:hover {
        background-color: #ffa;
    }

    .visit {
        background-color: orange;
        opacity: 0.5;
    }

    .visit-multi {
        background-color: orangered;
        opacity: 0.5;
    }

    .unoccupied{
        background-color: greenyellow;
        opacity: 0.5;
    }

    .hovered_window {
        opacity: 0.9;
    }

    .selected_window {
        background-color: green;
    }

    .hovered_window.visit {
        background-color: orangered;
    }

    .selected_window.visit {
        background-color: red;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }
</style>

<style>
    .has_error .multiselect__tags {
        border-color: red !important;
    }

    .has_error .multiselect__input {
        color: red !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/Visit/components/AddAction.vue?71e449e1